var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickWith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "#535B66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.642 3.299 2.047-2.047 2.041 2.046c.151-.244.298-.466.43-.697.257-.45.723-.674 1.218-.575.485.097.928.568 1 1.063.066.459-.181.896-.645 1.156-.213.12-.416.258-.621.386l2.032 2.021-2.074 2.071c-.115-.185-.257-.396-.382-.616-.215-.381-.529-.599-.969-.626-.535-.034-1.117.4-1.269.943-.15.537.087 1.064.595 1.347.214.119.417.256.612.377l-2.04 2.039-2.03-2.042c-.152.241-.298.451-.42.674-.195.354-.481.565-.881.626-.507.077-1.111-.315-1.297-.846-.184-.521.032-1.075.521-1.353.236-.135.463-.285.701-.431L6.168 6.776 8.23 4.714c.129.211.27.429.4.654.289.503.854.748 1.377.543.508-.199.853-.567.885-1.138.029-.517-.229-.88-.683-1.12-.199-.105-.384-.239-.567-.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.405 16.369c.261-.158.481-.298.708-.429a1.152 1.152 0 0 0 .363-1.697c-.351-.471-.84-.668-1.332-.53-.325.091-.557.296-.721.589-.122.218-.26.425-.387.631L0 12.892l2.02-2.012c-.063-.057-.106-.106-.16-.141a19 19 0 0 0-.571-.352 1.113 1.113 0 0 1-.24-1.744c.206-.215.431-.39.737-.432.488-.065.911.147 1.159.573.136.235.284.462.429.696l2.028-2.031L6.609 8.66c-.487.471-.746 1.079-.668 1.807.064.599.366 1.072.815 1.459.44.38.952.561 1.533.524a2.1 2.1 0 0 0 1.445-.699l1.205 1.207-2.05 2.041c.232.146.442.291.665.414.359.198.58.488.624.897.013.12.001.247-.022.366-.092.453-.586.898-1.058.964-.47.063-.905-.182-1.159-.639-.121-.217-.264-.423-.41-.655l-.159.151c-.456.455-.909.914-1.37 1.363a.43.43 0 0 1-.258.111c-.234.013-.497.064-.697-.02-.207-.087-.355-.314-.526-.483-.359-.352-.716-.705-1.114-1.099",
    fill: "#535B66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickWith);
export default __webpack_public_path__ + "static/media/ClickWith.1ad7bef9e3d72df4b2128702fd00d0e8.svg";
export { ForwardRef as ReactComponent };